<template>
  <div class="check-flow-modal">
    <Modal
      v-model="modal"
      title="结算核对"
      :closable="false"
      :mask-closable="false"
      width="700"
    >
      <div class="modal-main">
        <p style="margin-bottom: 8px">
          ①审批即表示对本次账单结算金额确认无误，请根据实际情况进行审批操作，系统账单<strong>仅供结算参考</strong>，实际以线下学生实际上课为准。如果设置成通过，该操作<strong>不可恢复</strong>，是否确认该操作？
        </p>
        <p style="margin-bottom: 8px">
          ②确定后，系统将设置账单中的课时为已结算，已结算后，课时将<strong>不再支持退款</strong>。
        </p>
        <p style="margin-bottom: 18px">
          ③结算时系统仅维护考勤结算状态，机构的实际分账部分请<strong>通过其他方式</strong>进行分账。
        </p>
        <p style="font-size: 18px">
          结算金额(元)：<span
            class="color-red"
            style="margin-right: 20px; font-size: 18px"
            >¥{{ totalFee }}</span
          >
          机构应结算金额(元)：<span class="color-red" style="font-size: 18px"
            >¥{{ orgFee }}</span
          >
        </p>
      </div>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleOk">已确认核对无误</Button>
      </div>
    </Modal>
    <SmsCodeModal
      ref="smsCodeModalRef"
      :modal-title="`短信验证`"
      :check-type="`wechatConfirm`"
      :phone-p-m="false"
      :modal-loading="modalLoading"
      @sendCode="delTrue"
    >
    </SmsCodeModal>
  </div>
</template>

<script>
import orderCenterApi from '@/request/orderCenter/index.js';
import SmsCodeModal from '@c/Base/SmsCodeModal.vue';
import { mapState } from 'vuex';
export default {
  components: {
    SmsCodeModal
  },
  inject: ['detailsData', 'tableType'],
  data() {
    return {
      modal: false,
      modalLoading: false,
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  // 
  watch: {



  },
  computed: {
    ...mapState(['userInfo']),
    totalFee() {
      return this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['settleAvailAmt'] : ''
    },
    orgFee() {
      return this.tableData.length > 0 ? this.tableData[this.tableData.length - 1]['totalDivideAmt'] : ''
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleShow() {
      this.modal = true
    },
    handleCancel() {
      this.modal = false
      this.$emit('on-cancel', {

      })
    },
    handleOk() {
      this.$refs.smsCodeModalRef.handleOpen();
    },
    delTrue(phoneCode) {
      this.setWechatConfirm(phoneCode)
    },
    async setWechatConfirm(code) {
      let settleAvailAmt = this.totalFee.replace(/,/g, '') * 100
      let merchantAmt = this.orgFee.replace(/,/g, '') * 100
      this.modalLoading = true;
      let res = await orderCenterApi.setWechatConfirm({
        settlementId: this.detailsData.sheetId,
        checkCode: code,
        settleAvailAmt: settleAvailAmt,
        merchantAmt: merchantAmt,
      })
      if (res.status == 200) {
        this.$refs.smsCodeModalRef.handleClose();
        this.$Modal.success({
          title: '温馨提示',
          content: '结算发起处理中，请稍后查看账单结算结果',
          onOk: () => {
            this.$emit('on-success')
            this.modal = false
          },
        });
      }
      this.modalLoading = false;
    }



  }
}
</script>

<style lang="scss" scoped>
.modal-main {
}
</style>